import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fr from "./fr.json";
import en from "./en.json";
import es from "./es.json";

const saved = typeof localStorage !== "undefined" ? localStorage.getItem("elvarify-lang") : null;

i18n.use(initReactI18next).init({
  resources: {
    fr: { translation: fr },
    en: { translation: en },
    es: { translation: es },
  },
  lng: saved || "fr",
  fallbackLng: "fr",
  interpolation: { escapeValue: false },
  returnObjects: true,
});

export default i18n;
